/* Bica Atelier: progressively enhanced, section-editor-safe components. */
(() => {
  if (!customElements.get('bica-finder')) {
    customElements.define('bica-finder', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.form.hidden = false;
        this.form.addEventListener('change', () => { this.expanded = false; this.filter(); }, { signal: this.abort.signal });
        this.querySelector('[data-reset]').hidden = false;
        this.classList.add('is-ready');
        this.cards = [...this.querySelectorAll('[data-coffee]')];
        this.previewLimit = Number(this.dataset.previewLimit) || Infinity;
        this.more = this.querySelector('[data-show-more]');
        this.expanded = false;
        this.more?.addEventListener('click', () => { this.expanded = true; this.filter(); }, { signal: this.abort.signal });
        this.steps = [...this.form.querySelectorAll('fieldset')];
        this.querySelector('[data-journey-controls]')?.remove();
        const controls = document.createElement('div'); controls.dataset.journeyControls = ''; controls.className = 'bica-journey-controls';
        controls.innerHTML = '<p data-journey-status aria-live="polite"></p><div class="bica-journey-track" aria-hidden="true"><span></span></div><div class="bica-journey-buttons"><button type="button" data-journey-back>السابق</button><button type="button" data-journey-next>الخطوة التالية ←</button></div>';
        controls.hidden = this.steps.length < 2;
        this.form.prepend(controls); this.setStep(0);
        controls.querySelector('[data-journey-next]').addEventListener('click',()=>this.setStep(this.step+1,true),{signal:this.abort.signal});
        controls.querySelector('[data-journey-back]').addEventListener('click',()=>this.setStep(this.step-1,true),{signal:this.abort.signal});

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.filter();
          const title = this.querySelector('[data-results-title]');
          title.focus({ preventScroll: true });
          const calm = document.documentElement.dataset.bicaMotion === 'none' || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
          title.scrollIntoView?.({ block: 'start', behavior: calm ? 'instant' : 'smooth' });
        }, { signal: this.abort.signal });
        this.querySelector('[data-reset]').addEventListener('click', () => {
          this.form.reset(); this.expanded = false; this.setStep(0);
          this.filter();
          this.form.querySelector('input').focus({ preventScroll: true });
        }, { signal: this.abort.signal });
        this.filter();
      }
      setStep(index,focus=false) {
        this.step=Math.max(0,Math.min(index,this.steps.length-1));
        this.steps.forEach((field,i)=>field.hidden=i!==this.step);
        this.querySelector('[data-journey-status]').textContent=`رحلة ذائقتك · ${this.step+1} / ${this.steps.length}`;
        this.querySelector('.bica-journey-track span').style.width=`${(this.step+1)/this.steps.length*100}%`;
        this.querySelector('[data-journey-back]').disabled=this.step===0;
        this.querySelector('[data-journey-next]').hidden=this.step===this.steps.length-1;
        this.form.querySelector('[type=submit]').hidden=this.step!==this.steps.length-1;
        if(focus)this.steps[this.step].querySelector('input:checked,input')?.focus({preventScroll:true});
      }
      filter() {
        const choices = new FormData(this.form);
        let count = 0;
        this.cards.forEach(card => {
          const match = ['flavor', 'caffeine'].every(key => !choices.has(key) || choices.get(key) === 'any' || choices.get(key) === card.dataset[key]);
          if (match) count++;
          const limited = choices.get('flavor') === 'any' && !this.expanded && count > this.previewLimit;
          card.hidden = !match || limited;
        });
        this.querySelector('[data-count]').textContent = String(count);
        if (this.more) {
          this.more.hidden = this.expanded || choices.get('flavor') !== 'any' || count <= this.previewLimit;
          this.more.textContent = this.dataset.moreLabel.replace('__COUNT__', Math.max(0, count - this.previewLimit));
        }
        const summary = [...this.form.querySelectorAll('input:checked')].map(input => input.nextElementSibling.textContent.trim()).join(' · ');
        this.querySelector('[data-feedback]').textContent = summary;
        if (document.documentElement.dataset.bicaMotion !== 'none' && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
          this.querySelector('[data-results-title]').animate?.([{opacity: .5}, {opacity: 1}], { duration: 180 });
        }
        this.querySelector('[data-empty]').hidden = count > 0;
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  if (!customElements.get('bica-brew')) {
    customElements.define('bica-brew', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.querySelector('[data-brew-controls]').hidden = false;
        this.method = this.querySelector('[data-method]');
        this.dose = this.querySelector('input[data-dose]');
        this.ratio = this.querySelector('input[data-ratio]');
        clearInterval(this.timer);
        this.elapsed = 0;
        this.started = null;
        const options = { signal: this.abort.signal };
        this.method.addEventListener('change', () => this.setMethod(), options);
        [this.dose, this.ratio].forEach(input => input.addEventListener('input', () => this.calculate(), options));
        this.querySelector('[data-timer-toggle]').addEventListener('click', () => this.toggleTimer(), options);
        this.querySelector('[data-timer-reset]').addEventListener('click', () => this.resetTimer(), options);
        if ([...this.method.options].some(option => option.value === this.dataset.productMethod)) this.method.value = this.dataset.productMethod;
        this.setMethod();
      }
      setMethod() {
        const option = this.method.selectedOptions[0];
        this.dose.value = option.dataset.dose;
        this.ratio.value = option.dataset.ratio;
        this.querySelector('[data-output-label]').textContent = option.dataset.output;
        const custom = this.querySelector('[data-custom-recipe]');
        const customActive = custom && custom.dataset.customRecipe === this.method.value;
        this.querySelectorAll('[data-recipe]').forEach(recipe => { recipe.hidden = customActive || recipe.dataset.recipe !== this.method.value; });
        if (custom) custom.hidden = !customActive;
        if (this.method.value === this.dataset.productMethod) {
          const dose = Number(this.dataset.productDose), ratio = Number(this.dataset.productRatio);
          if (Number.isFinite(dose) && dose >= 5 && dose <= 100 && Number.isFinite(ratio) && ratio >= 1 && ratio <= 25) {
            this.dose.value = String(dose); this.ratio.value = String(ratio);
          }
        }
        this.resetTimer();
        this.calculate();
      }
      calculate() {
        const valid = [this.dose, this.ratio].every(input => input.value !== '' && input.checkValidity());
        const output = this.querySelector('[data-water]');
        const value = valid ? String(Math.round(Number(this.dose.value) * Number(this.ratio.value) * 10) / 10) : '—';
        const changed = output.textContent !== value;
        output.textContent = value;
        this.resultAnimation?.cancel();
        if (changed && valid && document.documentElement.dataset.bicaMotion !== 'none' && !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode) {
          this.resultAnimation = output.animate?.([{transform:'translateY(4px)',opacity:.65},{transform:'translateY(0)',opacity:1}],{duration:240,easing:'ease-out'});
        }
        this.querySelector('[data-brew-error]').hidden = valid;
      }
      toggleTimer() {
        if (this.started !== null) {
          this.elapsed += Date.now() - this.started;
          this.started = null;
          clearInterval(this.timer);
        } else {
          this.started = Date.now();
          this.timer = setInterval(() => this.paintTimer(), 250);
        }
        this.querySelector('[data-timer-toggle]').textContent = this.started === null ? 'متابعة المؤقت' : 'إيقاف مؤقت';
        this.querySelector('[data-timer-status]').textContent = this.started === null ? 'المؤقت متوقف' : 'المؤقت يعمل';
        this.paintTimer();
      }
      paintTimer() {
        const seconds = Math.floor((this.elapsed + (this.started === null ? 0 : Date.now() - this.started)) / 1000);
        this.querySelector('[data-timer]').textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
      }
      resetTimer() {
        clearInterval(this.timer);
        this.started = null;
        this.elapsed = 0;
        this.querySelector('[data-timer-toggle]').textContent = 'ابدأ المؤقت';
        this.querySelector('[data-timer-status]').textContent = 'المؤقت جاهز';
        this.paintTimer();
      }
      disconnectedCallback() { this.abort?.abort(); clearInterval(this.timer); this.resultAnimation?.cancel(); }
    });
  }
})();

